var render = function () {
  var _vm$currentRound, _vm$currentRound$cont, _vm$currentRound$cont2, _vm$currentRound2, _vm$currentRound2$con;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'q-and-a',
      "customContentContainerStyles": {
        height: '100%'
      }
    }
  }, [_c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.showActivity ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "left-side"
  }, [_c('img', {
    attrs: {
      "alt": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$cont = _vm$currentRound.contentImage) === null || _vm$currentRound$cont === void 0 ? void 0 : _vm$currentRound$cont.image.description,
      "src": (_vm$currentRound$cont2 = (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$con = _vm$currentRound2.contentImage) === null || _vm$currentRound2$con === void 0 ? void 0 : _vm$currentRound2$con.image.src) !== null && _vm$currentRound$cont2 !== void 0 ? _vm$currentRound$cont2 : ''
    }
  })]), _c('div', {
    staticClass: "right-side"
  }, [_c('div', {
    staticClass: "q-a-instructions"
  }, [_c('audio-toggle-button', {
    attrs: {
      "sync-on-render": true
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.customInstructions)
    }
  })], 1), _c('div', {
    staticClass: "steps-container"
  }, [_c('div', {
    staticClass: "step-wrapper step-question"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Question:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.steps[0].question,
      "text-step": 0,
      "round-id": _vm.currentRound.roundIndex
    }
  })], 1), _c('div', {
    staticClass: "step-wrapper step-answer",
    attrs: {
      "aria-live": "assertive",
      "role": "region"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Answer:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.steps[0].answer,
      "text-step": 1,
      "round-id": _vm.currentRound.roundIndex
    }
  })], 1)])])]) : _vm._e()])]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }